<!-- New create/edit button -->
<div [ngClass]="{ 'has-edit-button': isEditMode }">
  <!-- edit button -->
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    documentTemplateQuery="new-IndexCards-document"
    folderTemplateQuery="new-IndexCards-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>
  <!-- has document -->
  <div
    *ngIf="indexCards && indexCards.length > 0"
    [ngClass]="{ 'has-edit-button': isEditMode }"
    [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom"
  >
    <div edsGrid>
      <div class="container {{ container }}">
        <!-- TODO: Replace with - EDS Section title -->
        <div edsRow *ngIf="content?.preTitle">
          <div edsCol>
            <p class="pre-title" edsSpacing="xs">{{ content.preTitle }}</p>
          </div>
        </div>
        <!--Title  -->
        <div *ngIf="content?.title" edsRow>
          <eds-title
            *ngIf="content.title"
            edsSpacing="md"
            edsCol
            [isLight]="true"
            [title]="content.title"
            size="h2"
            [theme]="titleColor"
          ></eds-title>
        </div>
        <div *ngIf="content?.summary" edsRow>
          <div edsCol>
            <!-- TODO: CHANGE TO DIV -->
            <p
              *ngIf="content.summary"
              edsSpacing="md"
              class="large"
              [innerHTML]="content.summary"
            ></p>
          </div>
        </div>

        <div edsRow>
          <!-- TODO: FIX EDS OVERFLOW -->
          <ng-container *ngFor="let card of indexCards">
            <!-- col -->
            <div edsCol edsSpacing="lg" [columnNumbers]="colNumbers">
              <eds-card-index
                *ngIf="card.title"
                [title]="card.title.displayText"
                [summary]="card.summary"
                [href]="card.title.url"
                [signInRequired]="
                  card.title?.signInLink | ftIsSignInRequired | async
                "
                [isNewWindow]="card.title?.target == '_blank' ? true : false"
                [externalLink]="card.title?.external"
                [externalSuffix]="card.title?.externalSuffix"
              ></eds-card-index>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- no document -->
  <div
    *ngIf="!indexCards && isEditMode"
    edsPadding
    [edsPaddingBottom]="padding"
    [edsPaddingTop]="padding"
    edsSpacing="xxl"
    class="no-document"
  >
    <div edsGrid class="no-document__component">
      <div class="no-document__overlay">
        Click to configure <strong>Index Cards</strong>
      </div>
    </div>
  </div>
</div>
